export default "__VITE_PUBLIC_ASSET__1caf3f23__"